import React, { useState, useEffect } from 'react'
import { initializeApp } from "firebase/app"
import axios from 'axios'
import html2canvas from "html2canvas"
import { toJpeg } from 'html-to-image';
import { jsPDF } from "jspdf"

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
import Badge from 'react-bootstrap/Badge'

import { ReactComponent as SpartekII } from './img/SPARTEK.svg'
import { ReactComponent as SpartekIII } from './img/SPARTEKIII.svg'
import { ReactComponent as ACUPARK } from './img/ACUPARKI.svg'
import { ReactComponent as ACUPARKII } from './img/ACUPARK.svg'
import { ReactComponent as ACUPARKIII } from './img/ACUPARKIII.svg'
import { ReactComponent as NORTE } from './img/NORTE.svg'
import { ReactComponent as ACTITEK } from './img/ACTITEK.svg'
import { ReactComponent as SITAPARK } from './img/SITAPARK.svg'

import logo from './img/LOGO.png'
import logo_b from './img/logo_b.png'
import star from './img/star.png'
import header from './img/header.png'

import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';

const firebaseConfig = {
  apiKey: "AIzaSyB-fnPhAuDUlRhq4Hm3ARtKUgZ4ynCTu3w",
  authDomain: "sph-planos.firebaseapp.com",
  databaseURL: "https://sph-planos-default-rtdb.firebaseio.com",
  projectId: "sph-planos",
  storageBucket: "sph-planos.appspot.com",
  messagingSenderId: "464047300814",
  appId: "1:464047300814:web:a725f6c1dfe2ee0b6e709f"
};
const app = initializeApp(firebaseConfig);

const formatoMXN = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
});

//const API_PATH = 'https://sph-planos-default-rtdb.firebaseio.com/spartek.json'
const API_PATH = 'https://sph-planos-default-rtdb.firebaseio.com/'

const STATUS_VENTA = {
  "0": { text: "Sin Estatus", bg: "#000", color: "#000" },
  "1": { text: "Disponible", bg: "#A3D233", color: "#fff" },
  "3": { text: "Apartado", bg: "#5c80e1", color: "#fff" },
  "6": { text: "Vendida", bg: "#F28B82", color: "#000" },
  "7": { text: "Bloqueado", bg: "#000", color: "#fff" }
};

const STATUS_RENTA = {
  "0": { text: "Sin Estatus", bg: "#000", color: "#000" },
  "2": { text: "Disponible", bg: "#A3D233", color: "#fff" },
  "4": { text: "Apartado", bg: "#5c80e1", color: "#fff" },
  "5": { text: "Rentada", bg: "#E89C8F", color: "#fff" },
  "8": { text: "Bloqueado", bg: "#000", color: "#fff" },
  "9": { text: "Usuario Final", bg: "#E89C8F", color: "#000" }
};

const BUILD_STATUS = {
  "land": { text: "Lote Industrial", bg: "#8A6F52", color: "#fff" },
  "building": { text: "En construcción menor al 80%", bg: "#64786C", color: "#fff" },
  "building80": { text: "En construcción mayor al 80%", bg: "#81B29A", color: "#fff" },
  "finish": { text: "Terminado", bg: "#A3D233", color: "#000" },
  "coming": { text: "Por construir", bg: "#64786C", color: "#fff" },
};

function App() {
  const [show, setShow] = useState()
  const [showMessage, setShowMessage] = useState()
  const [messageTitle, setMessageTitle] = useState('')
  const [messageBody, setMessageBody] = useState('')
  const [signed, setSigned] = useState(false)
  const [showToast, setShowToast] = useState(false)
  const [date, setDate] = useState()
  const [offer, setOffer] = useState('renta')
  const [park, setPark] = useState('SPARTEK')

  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")

  const [idHtml, setIdHtml] = useState("")
  const [id, setId] = useState("")
  const [el, setEl] = useState("")
  const [status, setStatus] = useState("")
  const [statusRent, setStatusRent] = useState("")
  const [name, setName] = useState("")
  const [mza, setMza] = useState("")
  const [lte, setLte] = useState("")
  const [land, setLand] = useState("")
  const [build, setBuild] = useState("")
  const [type, setType] = useState("")
  const [rent, setRent] = useState("")
  const [price, setPrice] = useState('')
  const [delivery, setDelivery] = useState('')
  const [building, setBuilding] = useState('')
  const [inBuild, setInBuild] = useState('')
  const [office, setOffice] = useState('')

  const [priceConst, setPriceConst] = useState("")
  const [priceMant, setPriceMant] = useState("")
  const [priceRent, setPriceRent] = useState("")
  const [totalRent, setTotalRent] = useState("")

  useEffect(() => {
    handleOnSubmit()

    const allWithClass = Array.from(
      document.getElementsByClassName('st48')
    );

    allWithClass.map(item => {
      item.addEventListener("click", () => testfunction(item));
    })

    var event = new Date();
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    setDate(event.toLocaleDateString('es-ES', options))
  }, []);

  useEffect(() => {
    handleOnSubmit()
    var classes = null

    if (park == 'SPARTEK' || park == 'ACUPARK III') {
      classes = document.getElementsByClassName('st90a')
    } else if (park == 'NORTE') {
      classes = document.getElementsByClassName('st23')
    } else if (park == 'SPARTEK III') {
      classes = document.getElementsByClassName('st0a')
    } else if (park == 'ACTITEK' || park == 'ACUPARK') {
      classes = document.getElementsByClassName('st7')
    } else if (park == 'SITAPARK') {
      classes = document.getElementsByClassName('st6')
    } else {
      classes = document.getElementsByClassName('st36a')
    }

    const allWithClass = Array.from(classes);

    allWithClass.map(item => {
      item.addEventListener("click", () => testfunction(item));
    })
  }, [park]);

  useEffect(() => {
    handleOnSubmit()
  }, [offer]);

  const testfunction = (e) => {
    setShow(true)

    setEl(e.dataset.element);
    setIdHtml(e.dataset.idhtml)
    setId(e.dataset.simpleid)
    setName(e.dataset.nombre)
    setLand(e.dataset.land)
    setBuild(e.dataset.build)
    setMza(e.dataset.mza)
    setLte(e.dataset.lte)
    setType(e.dataset.tipo)
    setStatus(e.dataset.estatus)
    setStatusRent(e.dataset.estatusrent)
    setRent(e.dataset.rent && e.dataset.rent != 'undefined' ? e.dataset.rent : "N/A")
    setPrice(e.dataset.price)
    setDelivery(e.dataset.delivery)
    setBuilding(e.dataset.building)
    setInBuild(e.dataset.building)
    setOffice(e.dataset.office)

    setPriceConst(e.dataset.priceconst)
    setPriceMant(e.dataset.pricemant)
    setPriceRent(e.dataset.pricerent)
    setTotalRent(e.dataset.totalrent)
  }

  const removeClasses = (element, second, rent) => {
    element?.classList?.remove?.("nbh-purpple");
    element?.classList?.remove?.("nbh-orange");
    element?.classList?.remove?.("nbh-red");
    element?.classList?.remove?.("nbh-blue");
    element?.classList?.remove?.("nbh-green");
    //element?.classList?.remove?.("nbh-green-b");
    //element?.classList?.remove?.("nbh-green-c");
    element?.classList?.remove?.("nbh-yellow");
    element?.classList?.remove?.("nbh-brown");
    element?.classList?.remove?.("nbh-gray");

    element?.classList?.remove?.("nbs-red");
    element?.classList?.remove?.("nbs-gray");

    element?.classList?.remove?.("nbh-graylight");
    element?.classList?.remove?.("nbh-land");
    element?.classList?.remove?.("nbh-comming");
    element?.classList?.remove?.("nbh-arena");
    element?.classList?.remove?.("nbh-darkgreen");
    element?.classList?.remove?.("nbh-lightgreen");

    //second?.classList?.remove?.("hide");
    //rent?.classList?.remove?.("hide");
  }

  const handleOnSubmit = (token) => {

    axios.get(API_PATH + (park == 'ACUPARK II' ? 'acupark.json' : (park == 'ACUPARK' ? 'acuparki.json' : park.toLowerCase().replaceAll(' ', '') + '.json')), {}, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {
      const elements = response.data
      //console.log("response", response)

      elements.map((element, index) => {
        const svgPrincipal = document.getElementById(`${element.IdHtml}p`);
        const svgCloned = document.getElementById(`c${element.IdHtml}p`);
        const svgSecond = document.getElementById(`e${element.IdHtml}p`);
        const svgRent = document.getElementById(`i${element.IdHtml}p`);

        removeClasses(svgPrincipal, svgSecond, svgRent)
        /*if (element.Estatus == 1) {
          if( offer == 'venta') svgPrincipal?.classList?.add?.("nbh-green");
        } else if (element.Estatus == 3) {
          if( offer == 'venta' ) svgPrincipal?.classList?.add?.("nbh-blue");
        } else if (element.Estatus == 2) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-green");
          //if( offer == 'venta') svgPrincipal?.classList?.add?.("nbs-red");
        } else if (element.Estatus == 4) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-blue");
        } else if (element.Estatus == 5) {
          if( offer == 'renta') svgPrincipal?.classList?.add?.("nbh-red");
        }*/

        if (offer == 'venta') {
          if (element.Estatus == 1) {
            if (element.inBuild == 'land') svgPrincipal?.classList?.add?.("nbh-land");
            else if (element.inBuild == 'building80')
              svgPrincipal?.classList?.add?.("nbh-lightgreen");
            else if (element.inBuild == 'building' || element.inBuild == 'coming')
              svgPrincipal?.classList?.add?.("nbh-lightgreen");
            else svgPrincipal?.classList?.add?.("nbh-green");
          } else if (element.Estatus == 3)
            svgPrincipal?.classList?.add?.("nbh-blue");
          else if (element.Estatus == 6)
            svgPrincipal?.classList?.add?.("nbh-graylight");
          else if (element.Estatus == 7)
            svgPrincipal?.classList?.add?.("nbh-gray");

          /*if ((element.Estatus == 0 || element.Estatus == 2 || element.Estatus == 4 || element.Estatus == 5) && element.investor != '-') {
            svgPrincipal?.classList?.add?.("nbh-red");
          }*/

          /*if(element.ForceAvailable == true){
            svgPrincipal?.classList?.add?.("nbh-green");
          }*/
        }

        if (offer == 'renta') {
          if (element.EstatusRent == 2) {
            if (element.inBuild == 'land') svgPrincipal?.classList?.add?.("nbh-land");
            else if (element.inBuild == 'building80')
              svgPrincipal?.classList?.add?.("nbh-lightgreen");
            else if (element.inBuild == 'building' || element.inBuild == 'coming')
              svgPrincipal?.classList?.add?.("nbh-comming");
            else svgPrincipal?.classList?.add?.("nbh-green");
          } else if (element.EstatusRent == 4)
            svgPrincipal?.classList?.add?.("nbh-blue");
          else if (element.EstatusRent == 5)
            svgPrincipal?.classList?.add?.("nbh-darkgreen");
          else if (element.EstatusRent == 8)
            svgPrincipal?.classList?.add?.("nbh-gray");
          else if (element.EstatusRent == 9)
            svgPrincipal?.classList?.add?.("nbh-darkgreen");
          //svgPrincipal?.classList?.add?.("nbh-orange");

          /*if (element.rent != '-') {
            svgPrincipal?.classList?.add?.("nbh-red");
          }*/
        }
        /*else if (element.Estatus == 4)
          svgPrincipal?.classList?.add?.("nbh-blue");
        else if (element.Estatus == 5)
          svgPrincipal?.classList?.add?.("nbh-green");
        else if (element.Estatus == 6)
          svgPrincipal?.classList?.add?.("nbh-yellow");
        else
          svgPrincipal?.classList?.add?.("nbh-brown");*/

        svgCloned?.setAttribute("data-idhtml", (element.IdHtml)?.toString());
        svgCloned?.setAttribute("data-simpleid", element.id);
        svgCloned?.setAttribute("data-element", index);
        svgCloned?.setAttribute("data-estatus", element.Estatus);
        svgCloned?.setAttribute("data-estatusrent", element.EstatusRent);
        svgCloned?.setAttribute("data-tipo", (element.Tipo)?.toString());
        svgCloned?.setAttribute("data-land", element.Land);
        svgCloned?.setAttribute("data-build", element.Build);
        svgCloned?.setAttribute("data-lte", element.Lte);
        svgCloned?.setAttribute("data-mza", element.Mza);
        svgCloned?.setAttribute("data-nombre", element.Nombre);
        svgCloned?.setAttribute("data-rent", element.rent);
        svgCloned?.setAttribute("data-building", element.inBuild);
        svgCloned?.setAttribute("data-price", element.price);
        svgCloned?.setAttribute("data-delivery", element.delivery);
        svgCloned?.setAttribute("data-office", element.office);

        svgCloned?.setAttribute("data-priceconst", element.priceConst);
        svgCloned?.setAttribute("data-pricemant", element.priceMant);
        svgCloned?.setAttribute("data-pricerent", (element.priceRent)?.toString());
        svgCloned?.setAttribute("data-totalrent", element.totalRent);

        svgSecond?.classList?.add?.("hide");
        svgRent?.classList?.add?.("hide");

        // PRIORIDAD DE COSNTRUCCION
        /*if (element.inBuild == 'building80') {
          removeClasses(svgPrincipal, svgSecond, svgRent)
          svgPrincipal?.classList?.add?.("nbh-green");
        } else if (element.inBuild == 'building' || element.inBuild == 'coming') {
          removeClasses(svgPrincipal, svgSecond, svgRent)
          svgPrincipal?.classList?.add?.("nbh-comming");
        }*/

        /*else if (offer == 'venta' && (element.EstatusRent == 5)) {
          removeClasses(svgPrincipal, svgSecond, svgRent)
          svgPrincipal?.classList?.add?.("nbh-darkgreen");
        }*/

        /* ORIGINAL
        if (element.inBuild == 'building') {
          //svgSecond?.classList?.add?.("hide");
          svgSecond?.classList?.add?.("on-construction");
          if (offer == 'renta' && element.EstatusRent == 2) {
            svgPrincipal?.classList?.remove?.("nbh-green");
            svgPrincipal?.classList?.add?.("nbh-green-c");
          }
        } else if (element.inBuild == 'coming') {
          svgSecond?.classList?.add?.("coming-soon");
          if (offer == 'renta' && element.EstatusRent == 2) svgPrincipal?.classList?.remove?.("nbh-green");
        } else if (element.inBuild == 'building80') {
          svgSecond?.classList?.add?.("on-construction");
          if (offer == 'renta' && element.EstatusRent == 2) {
            svgPrincipal?.classList?.remove?.("nbh-green");
            svgPrincipal?.classList?.add?.("nbh-green-b");
          }
        } else if (element.inBuild == 'land') {
          svgSecond?.classList?.add?.("on-land");
        } else {
          svgSecond?.classList?.add?.("hide");
          //svgPrincipal?.classList?.add?.("nbs-red");
        }

        if (offer == 'venta' && (element.EstatusRent == 5)) {
          svgRent?.classList?.add?.("show");
          svgRent?.classList?.add?.("st-rent");
        } else
          svgRent?.classList?.add?.("hide");
        */

        //if( offer == 'venta' && element.rent != '-')
        /*if( offer == 'venta' && element.investor == '-' && element.rent != '-')
          svgPrincipal?.classList?.add?.("nbs-blue");
        else  svgPrincipal?.classList?.remove?.("nbs-blue");*/

      })

    }).catch(function (err) {
      console.log("ERROR", err)
    });
  }

  const downloading = () => {
    setShowToast(true)

    setTimeout(() => {
      printPDF()
    }, 1000);
  }

  const prepareSVGForExport = (container) => {
    const svgs = container.querySelectorAll("svg");

    svgs.forEach((svg) => {
      const elements = svg.querySelectorAll("*");

      elements.forEach((el) => {
        const computedStyle = window.getComputedStyle(el);

        if (computedStyle.display === "none" || el.style.display === "none") {
          el.setAttribute("display", "none");
          el.style.display = "none";
        } else {
          const fill = computedStyle.fill;
          const stroke = computedStyle.stroke;

          if (fill && fill !== "none") {
            el.setAttribute("fill", fill);
            el.style.fill = fill;
          }
          if (stroke && stroke !== "none") {
            el.setAttribute("stroke", stroke);
            el.style.stroke = stroke;
          }
        }
      });
    });
  };

  const printPDF = () => {
    const infoPageElement = document.getElementById("App");

    prepareSVGForExport(infoPageElement);

    toJpeg(infoPageElement, {
      quality: 0.85,
      pixelRatio: 2,
      cacheBust: true,
      fetchRequestInit: {
        mode: 'cors',
      },
    })
      .then((dataUrl) => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        pdf.addImage(dataUrl, 'JPEG', 5, 5, 200, 288);
        pdf.save(`${new Date().toISOString()}.pdf`);
        setShowToast(false);
      })
      .catch((error) => {
        console.error('Error al generar el PDF:', error);
        setShowToast(false);
      });
  };

  const printPDF_OPTIMIZADO = () => {
    const infoPageElement = document.getElementById("App");
    const pdf = new jsPDF('p', 'mm', 'a4');

    html2canvas(infoPageElement, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      logging: false
    }).then(canvas => {
      const imgData = canvas.toDataURL("image/jpeg", 0.8);

      pdf.addImage(imgData, "JPEG", 5, 5, 200, 288);
      pdf.save(`${new Date().toISOString()}.pdf`);

      setShowToast(false);
    }).catch(err => {
      console.error("Error al generar el PDF", err);
      setShowToast(false);
    });
  };

  const printPDF_OLD = () => {
    const infoPageElement = document.getElementById("App");
    const pdf = new jsPDF('p', 'mm', 'a4');
    setShowToast(true)

    html2canvas(infoPageElement, {
      onclone: document => {
        //document.getElementById("print").style.visibility = "hidden";
      },
      scale: 2,
      useCORS: true,
      allowTaint: false
    }).then(canvas => {
      /*var a = document.createElement('a');
      a.href = canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
      a.download = `${new Date().toISOString()}.jpg`;
      a.click();*/

      pdf.addImage(canvas.toDataURL("image/jpeg"), "JPEG", 5, 5, 200, 288);
      pdf.save(`${new Date().toISOString()}.pdf`);

      /*const imgData = canvas.toDataURL("image/jpeg");
      const pdf = new jsPdf('p', 'mm', 'a4');

      //pdf.addImage(imgData, "JPEG", 10, 10, 297.64, 420.94);
      pdf.addImage(imgData, "JPEG", 10, 10);
      pdf.save(`${new Date().toISOString()}.pdf`);*/
    });

  };

  const reloadPage = () => {
    handleOnSubmit()
    setShowMessage(false)
    //window.location.reload()
  }

  const desformatearDivisa = (valorFormateado, locale = 'es-MX') => {
    const limpio = valorFormateado
      .replace(/[^\d.-]/g, '')
      .replace(',', '');

    return parseFloat(limpio);
  }

  const renderPrecioVenta = () => {
    return (priceConst && priceConst > 0)
      ? formatoMXN.format(((parseFloat((desformatearDivisa(priceConst) * parseFloat(build))) - parseFloat((3000 * parseFloat(land)))) * 1.16) + parseFloat((3000 * parseFloat(land))))
      : price;
  };

  const renderPrecioRenta = () => {
    return priceRent
      ? formatoMXN.format(parseFloat((desformatearDivisa(priceRent) * parseFloat(build)) * 1.16) + parseFloat((desformatearDivisa(priceMant) * parseFloat(build) * 1.16)))
      : '';
  };

  const currentStatus = offer === 'venta'
    ? (STATUS_VENTA[status] || { text: "Sin Estatus", bg: "secondary" })
    : (STATUS_RENTA[statusRent] || { text: "Sin Estatus", bg: "secondary" });

  return (
    <div className="App" align="center">
      <Modal show={showToast}>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {'Descargando...'}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Tu Descarga comenzará en breve.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowToast(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showMessage}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header onHide={() => setShow(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {messageTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{messageBody}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => reloadPage()}>Aceptar</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header onHide={() => setShow(false)}>
          <Modal.Title id="contained-modal-title-vcenter">
            <img src={logo_b} className="logo_b" />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {building === 'land' ? 'Lote industrial ' + name.replace('nave ', '') : name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Container className="py-4 bg-white rounded shadow-sm border">
            <Row className="g-4">

              {/* Sección de Estatus Principales */}
              <Col md={6} className="border-bottom pb-3" align="center">
                <div className="text-muted small text-uppercase fw-bold" align="left">Estatus de la propiedad</div>
                <div style={{ color: currentStatus.bg, fontSize: '30px', fontWeight: 600 }} className="rounded text-uppercase" align="left">
                  {currentStatus.text}
                </div>
              </Col>

              {inBuild &&
                <Col md={6} className="border-bottom pb-3" align="center">
                  <div className="text-muted small text-uppercase fw-bold" align="left">Etapa de desarrollo</div>
                  <div style={{ color: BUILD_STATUS[inBuild].bg, fontSize: '30px', fontWeight: 600 }} className="rounded text-uppercase" align="left">
                    {BUILD_STATUS[inBuild].text || 'No especificado'}
                  </div>
                </Col>
              }

              {/* Datos de Ubicación y Precios */}
              <Col md={6}>
                <div className="mb-0 p-3 bg-light rounded-3">
                  <h6 className="border-bottom pb-2 mb-3 text-uppercase">Datos de la unidad</h6>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Manzana:</Col>
                    <Col xs={6} className="fw-bold">{mza || '-'}</Col>
                  </Row>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Lote:</Col>
                    <Col xs={6} className="fw-bold">{lte || '-'}</Col>
                  </Row>
                </div>
              </Col>

              <Col md={6}>
                <div className="mb-0 p-3 bg-light rounded-3">
                  <h6 className="border-bottom pb-2 mb-3 text-uppercase">Características</h6>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Terreno:</Col>
                    <Col xs={6} className="fw-bold">{land ? `${parseFloat(land).toFixed(3)} m²` : '-'}</Col>
                  </Row>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Construcción:</Col>
                    <Col xs={6} className="fw-bold">{build ? `${parseFloat(build - office).toFixed(3)} m²` : '-'}</Col>
                  </Row>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Mezanine:</Col>
                    <Col xs={6} className="fw-bold">{office ? `${parseFloat(office).toFixed(3)} m²` : '-'}</Col>
                  </Row>

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">Total Construcción:</Col>
                    <Col xs={6} className="fw-bold">{build ? `${parseFloat(build).toFixed(3)} m²` : '-'}</Col>
                  </Row>

                </div>
              </Col>

              {/* Dimensiones y Tiempos */}
              {/*<Col md={6}>
                <div className="mb-0 p-3 bg-light rounded-3">
                  <h6 className="border-bottom pb-2 mb-3 text-uppercase">Valor de Inversión</h6>

                  {offer === 'renta' && (
                    <Row className="mb-2">
                      <Col xs={6} className="text-muted">Precio renta x m²:</Col>
                      <Col xs={6} className="fw-bold">{priceRent || '-'}</Col>
                    </Row>
                  )}

                  {offer === 'venta' && (
                    <Row className="mb-2">
                      <Col xs={6} className="text-muted">{building === 'land' ? 'Precio x m² terreno: ' : 'Precio x m² construcción:'}</Col>
                      <Col xs={6} className="fw-bold">{priceConst || '-'}</Col>
                    </Row>
                  )}

                  {offer === 'renta' && (
                    <Row className="mb-2">
                      <Col xs={6} className="text-muted">Precio x m² mantenimiento:</Col>
                      <Col xs={6} className="fw-bold">{priceMant || '-'}</Col>
                    </Row>
                  )}

                  <Row className="mb-2">
                    <Col xs={6} className="text-muted">
                      {offer === 'venta' ? 'Precio de contado (IVA incluido):' : 'Precio de renta total:'}
                    </Col>
                    <Col xs={6} className="fw-bold text-success">
                      {offer === 'venta' ? renderPrecioVenta() : renderPrecioRenta()}
                    </Col>
                  </Row>

                </div>
              </Col>*/}

              {offer === 'venta' && (
                <Col md={6}>
                  <div className="mb-0 p-3 bg-light rounded-3">
                    <h6 className="border-bottom pb-2 mb-3 text-uppercase">Avance del Proyecto</h6>

                    <Row className="mb-2">
                      <Col xs={6} className="text-muted">Entrega Estimada:</Col>
                      <Col xs={6} className="fw-bold text-secondary">{delivery || '-'}</Col>
                    </Row>

                  </div>
                </Col>
              )}

              {/*statusRent == 5 && offer === 'venta' &&
                <>
                  <Col md={3} />
                  <Col md={6} className="pb-3" align="center">
                    <div style={{ color: '#E89C8F', fontSize: '30px', fontWeight: 600 }} className="rounded text-uppercase">
                      Rentada
                    </div>
                  </Col>
                  <Col md={3} />
                </>
              */}

              <Col md={12}>
                <div className="py-3" style={{ fontSize: '12px' }}> Los datos son de carácter informativo y podrán ser modificados sin previo aviso, SPH se reserva el derecho de actualizar M2, precios, condiciones y disponibilidad en cualquier momento. </div>
              </Col>

            </Row>
          </Container>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={() => setShow(false)}>Cerrar</Button>
        </Modal.Footer>
      </Modal>

      <Navbar collapseOnSelect bg="light" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand ><a href='/'><img src={logo} height="45px" /></a></Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav" >
            <Nav className="me-auto">
            </Nav>
            <Nav className='align-items-center'>
              <Nav.Link href="/">
                <div style={{ color: "#21283a", fontWeight: 700 }}>Regresar al inicio</div>
              </Nav.Link>
              <Nav.Link onClick={downloading}>
                <div style={{ backgroundColor: "#90bf32", padding: '10px 15px', borderRadius: '15px', color: '#fff', fontWeight: 700 }}>Descargar Plano</div>
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container>
        <Row>
          <Col align="center">
            <div className="header-filter">
              {/*<div className="sub-title-green" style={{ marginTop: "0px", fontSize: "50px" }}> Planos de disponibilidad </div>*/}
              <Form.Group className="mb-3">
                <Form.Label >Parque Industrial SPH</Form.Label>
                <Form.Select aria-label="Parque" size="sm" value={park} onChange={(e) => { setPark(e.target.value); setOffer('renta'); }}>
                  <option>Selecciona un Parque</option>
                  <option value="SPARTEK">SPARTEK</option>
                  <option value="SPARTEK III">SPARTEK III</option>
                  <option value="ACUPARK">ACUPARK</option>
                  <option value="ACUPARK II">ACUPARK II</option>
                  <option value="ACUPARK III">ACUPARK III</option>
                  <option value="NORTE">NORPONIENTE</option>
                  <option value="ACTITEK">ACTITEK</option>
                  <option value="SITAPARK">SITAPARK</option>
                </Form.Select>
              </Form.Group>

              <Form.Label >Oferta</Form.Label>
              <Container>
                <Row>
                  <Col>
                    <Form.Check
                      inline
                      label="Renta"
                      name="group1"
                      type='radio'
                      checked={offer == 'renta' ? true : false}
                      onChange={() => setOffer('renta')}
                    />
                    {park !== 'ACUPARK III' && <Form.Check
                      inline
                      label="Venta"
                      name="group1"
                      type='radio'
                      checked={offer == 'venta' ? true : false}
                      onChange={() => setOffer('venta')}
                    />}
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
        </Row>
      </Container>
      <br />
      <div id="App" className="app-container">
        <div className='map-container'>
          { /*<img src={ header } className='header-style' />*/}
          <div className="header">
            <Container>
              <Row className="align-items-center" style={{ position: 'relative' }}>
                <Col md={3} xs={12} className='nav-style'>
                  <div>
                    <img src={logo_b} className="logo" />
                  </div>
                </Col>
                <Col md={6} xs={12} align="left">
                  <div className="title">
                    PARQUE INDUSTRIAL
                  </div>
                  <div className="title-big">
                    {park == 'NORTE' ? 'NORPONIENTE' : park}
                  </div>
                </Col>
                <Col md={3} xs={12}>
                  <div className='date'>{date}</div>
                  <div className='subtitle'>
                    <div>{offer}</div>
                    <div style={{ fontSize: '10px', fontFamily: 'Rubik', paddingTop: '15px', lineHeight: '15px' }}>Para consultar precios, metraje y fechas de entrega, dar click sobre la nave.</div>
                  </div>
                  <div className='date'> { } </div>
                </Col>
              </Row>
            </Container>
          </div>

          <br /><br />

          <Container style={{ paddingLeft: '30px' }}>
            <Row align="left" className='align-items-center'>
              <Col md={12}>
                <Container>
                  <Row className='align-items-center'>

                    <Col md={'auto'} className={(park === 'NORTE' || park === 'SPARTEK III') ? 'hide' : 'label-container'}>
                      <Row className='align-items-center'>
                        <Col md={'auto'} sx={'auto'} className='p-0'>
                          <span className='circle-green'></span>
                        </Col>
                        <Col>
                          <div className="circle-legend">Disponible: Entrega inmediata</div>
                          {/*offer == 'renta' && <div className="circle-small">Nave disponible para renta</div>*/}
                          {/*offer == 'venta' && <div className="circle-small">Nave disponible para venta</div>}*/}
                        </Col>
                      </Row>
                    </Col>

                    {(offer === 'renta' || (park === 'NORTE' || park === 'SPARTEK III')) &&
                      <Col md={'auto'} className='label-container'>
                        <Row className='align-items-center'>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-lightgreen'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">Disponible en construcción</div>
                          </Col>
                        </Row>
                      </Col>
                    }

                    {offer == 'renta' &&
                      <Col md={'auto'} className='px-4 py-2 label-container'>
                        <Row className='align-items-center'>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-comming'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">No disponible</div>
                            {/*<div className="circle-small">{'Por construirse ó construcción <80%'}</div>*/}
                          </Col>
                        </Row>
                      </Col>
                    }
                    {/*<Col md={'auto'} className='px-4 py-2'>
                      <Row>
                        <Col md={'auto'} sx={'auto'} className='p-0'>
                          <span className='circle-arena'></span>
                        </Col>
                        <Col>
                          <div className="circle-legend">En construcción</div>
                          <div className="circle-small">Nave en proceso de construcción</div>
                        </Col>
                      </Row>
                    </Col>*/}
                    <Col md={'auto'} className='px-4 py-2 label-container'>
                      <Row className='align-items-center'>
                        <Col md={'auto'} sx={'auto'} className='p-0'>
                          <span className='circle-gray'></span>
                        </Col>
                        <Col>
                          <div className="circle-legend">Bloqueada</div>
                          {/*<div className="circle-small">Nave con proceso comercial en negociación</div>*/}
                        </Col>
                      </Row>
                    </Col>
                    {offer == 'renta' &&
                      <Col md={'auto'} className='px-4 py-2 label-container'>
                        <Row className='align-items-center'>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-darkgreen'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">Arrendado / Usuario Final</div>
                            {/*<div className="circle-small">Nave ya rentada</div>*/}
                          </Col>
                        </Row>
                      </Col>
                    }
                    {offer == 'venta' &&
                      <Col md={'auto'} className='px-4 py-2 label-container'>
                        <Row className='align-items-center'>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-graylight'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">Vendida</div>
                            {/*<div className="circle-small">Nave ya vendida</div>*/}
                          </Col>
                        </Row>
                      </Col>
                    }
                    <Col md={'auto'} className='px-4 py-2 label-container'>
                      <Row className='align-items-center'>
                        <Col md={'auto'} sx={'auto'} className='p-0'>
                          <span className='circle-blue'></span>
                        </Col>
                        <Col>
                          <div className="circle-legend">Apartado</div>
                          {/*<div className="circle-small">Nave apartada</div>*/}
                        </Col>
                      </Row>
                    </Col>
                    {/*offer == 'renta' &&
                      <Col md={'auto'} className='px-4 py-2 label-container'>
                        <Row>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-gold'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">No disponible</div>
                            <div className="circle-small">Nave ocupada por usuario final</div>
                          </Col>
                        </Row>
                      </Col>
                    */}
                    {offer == 'venta' &&
                      <Col md={'auto'} className='px-4 py-2 label-container'>
                        <Row className='align-items-center'>
                          <Col md={'auto'} sx={'auto'} className='p-0'>
                            <span className='circle-brown'></span>
                          </Col>
                          <Col>
                            <div className="circle-legend">Lote Industrial</div>
                            {/*<div className="circle-small">Terreno disponible</div>*/}
                          </Col>
                        </Row>
                      </Col>
                    }
                  </Row>
                </Container>
              </Col>
              {/*<Col md={6}>
                <Container>
                  <Row>
                    {offer == 'venta' &&
                      <Col md={'auto'}>
                        <span className='circle-yellow'></span>&nbsp;&nbsp;&nbsp;
                        <span className="circle-legend">Arrendado</span>
                      </Col>
                    }
                    <Col md={'auto'}>
                      <span className='circle-land'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Lote industrial</span>
                    </Col>
                    <Col md={'auto'}>
                      <span className='circle-red'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">En construcción</span>
                    </Col>
                    <Col md={'auto'}>
                      <span className='circle-lightblue'></span>&nbsp;&nbsp;&nbsp;
                      <span className="circle-legend">Por construir</span>
                    </Col>
                    { //offer == 'venta' &&
                      //<Col md={ 'auto' }> 
                        //<span className='squart-red'></span>&nbsp;&nbsp;&nbsp;
                        //<span className="circle-legend">Disponible para renta</span>
                      //</Col>
                    }
                  </Row>
                </Container>
              </Col>*/}
            </Row>
          </Container>

          {park == 'SPARTEK' &&
            <SpartekII />
          }
          {park == 'SPARTEK III' &&
            <SpartekIII />
          }
          {park == 'ACUPARK' &&
            <ACUPARK />
          }
          {park == 'ACUPARK II' &&
            <ACUPARKII />
          }
          {park == 'ACUPARK III' &&
            <ACUPARKIII />
          }
          {park == 'NORTE' &&
            <NORTE />
          }
          {park == 'ACTITEK' &&
            <ACTITEK />
          }
          {park == 'SITAPARK' &&
            <SITAPARK />
          }

          <div className="footer">
            <Container>
              <Row className="align-items-center">
                <Col>
                  <div className='footer-text'><b>Los datos son de carácter informativo y podrán ser modificados sin previo aviso, SPH se reserva el derecho de actualizar M2, precios, condiciones y disponibilidad en cualquier momento.</b></div>
                  <div className='footer-text'>Grupo SPH, Lic. Manuel Gómez Morín, piso 11, oficina 11A, 76090, Centro Sur, Qro.</div>
                </Col>
              </Row>
            </Container>
          </div>

          {/* <Container>
            <Row align="left">
              <Col md={ 4 }> 
                <span className='circle-purple'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida y rentada</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-orange'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida - Disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-red'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Vendida - No construida</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-blue'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-green'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">Rentada - Disponible para venta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-yellow'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">RA y disponible para renta</span>
              </Col>
              <Col md={ 4 }> 
                <span className='circle-brown'></span>&nbsp;&nbsp;&nbsp;
                <span className="circle-legend">RC, RA y disponible para renta</span>
              </Col>
            </Row>
            </Container> */}
        </div>
      </div>

      <br />
      <br />
    </div >
  );
}

export default App;
